/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/date/FormatCurrentDate.ts
 * @create:      2025-06-27 21:46:11.827
 * @modify:      2025-07-11 21:19:12.901
 * @version:     6.0.0
 * @times:       10
 * @lines:       49
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { DateTimeFormat } from "../enum/DateTimeFormat";
import { FormatDate } from "./FormatDate";

/**
 * Formats the current date and time according to the specified format and timezone offset.
 *
 * @param format - Optional. The format to use for the date output. Can be a `DateTimeFormat` object or a string pattern.
 * @param timezoneOffset - Optional. The timezone offset in minutes to apply to the current date.
 * @returns The formatted current date as a string.
 * 
 * @since 4.0.0
 * @version 2021-12-14
 */
export function FormatCurrentDate(format?: DateTimeFormat | string, timezoneOffset?: number): string {
    return FormatDate(new Date(), format, timezoneOffset);
}
